import React from 'react';
import { useSelector } from 'react-redux';
import { selectHoveredNoFlyZoneId } from '@src/core/features/zones/redux';
import { ZonePolygonProps } from './types';
import ArcZonePolygon from '@src/core/ui/arc-zone-polygon';

const ZonePolygon: React.FC<ZonePolygonProps> = (props) => {
  const { zone } = props;
  const hoveredNoFlyZoneId = useSelector(selectHoveredNoFlyZoneId);
  const isHovered =
    hoveredNoFlyZoneId != null && Number(hoveredNoFlyZoneId) === Number(zone.id);

  const path = (zone.polygonCoordinates ?? []) as google.maps.LatLngLiteral[];
  if (path.length < 1) {
    return null;
  }

  return (
    <ArcZonePolygon
      path={path}
      label={zone.name}
      type={zone.zoneType}
      strokeHighlight={isHovered}
    />
  );
};

export default ZonePolygon;
